/**
 * Used for detecting when an element is rendered
 * @param {Node} element - The element that is waiting to be rendered
 * @param {Function} callback - The function that fires after rendering
 */

export function onRender(element, callback) {
  element.getBoundingClientRect();
  requestAnimationFrame(() => requestAnimationFrame(() => callback()));
}

/**
 * A shorthand for transitionEnd
 * @param {Node} element - Element that is being transitioned
 * @param {Function} callback - What to do afterwards
 */
export function onTransitionEnd(element, callback) {
  const transitionEndFn = () => {
    element.removeEventListener('transitionend', transitionEndFn);
    callback();
  };
  element.addEventListener('transitionend', transitionEndFn);
}

/**
 * String to Document Fragment
 * @param {string} html - html string
 * @returns {Node} fragment - the returned document fragment
 */

export function htmlToFragment(html) {
  const proxy = document.createElement('div');
  proxy.innerHTML = html;
  const fragment = document.createDocumentFragment();
  while (proxy.firstChild) fragment.appendChild(proxy.firstChild);
  return fragment;
}

/**
 * Default fetch options. If there is a body - it's a POST
 * @param {Object} body
 * @returns {Object}
 */

export function fetchOptions(body) {
  const csrfToken = document
    .querySelector('meta[name="csrf"]')
    .getAttribute('content');

  const headers = new Headers({
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRFToken': csrfToken,
  });

  const options = {
    credentials: 'include',
    headers,
  };

  if (typeof body !== 'undefined') {
    options.method = 'POST';

    if (typeof body === 'object') {
      options.body = JSON.stringify(body);
      headers.append('Content-Type', 'application/json');
    }
  }

  return options;
}

/**
 * Handles errors for fetch requests
 * @param {Object} response
 */

export function handleErrors(response) {
  if (!response.ok) throw Error(response.statusText);
  return response;
}

/**
 * Remove element
 * @param {HTMLElement} el
 */
export function removeElement(el) {
  el.parentNode.removeChild(el);
}

/**
 * Checks if an event is a left click
 * @param {Event} event
 * @returns {Boolean}
 */

export function isLeftClick(event) {
  if (event.button === 0 && !event.ctrlKey && !event.metaKey) return 1;
  return 0;
}

/**
 * Data loader - optional body turns it into a POST
 * @param {String} url
 * @param {Object} [body]
 * @returns {String}
 */
export function loadData(url, body) {
  return fetch(url, fetchOptions(body))
    .then(handleErrors)
    .then(response => {
      if (response.headers.get('Content-Type') === 'application/json')
        return response.json();
      else if (response.headers.get('Content-Type') === 'text/html')
        return response.text();
      return 'Something went wrong. Check out the log.';
    });
}



// WEBPACK FOOTER //
// ./src/js/helpers.js